import React, { useContext } from 'react';
import { AuthenticationContext } from '../contexts/AuthenticationContext';

export function useAuthenticationContext() {
    return useContext(AuthenticationContext);
}
